import React, { FC, memo, useRef } from 'react'

import { observer } from 'mobx-react'
import { NavLink } from 'react-router-dom'

import cn from 'classnames'
import PopupState, { bindPopover, bindTrigger } from 'material-ui-popup-state'

import Popover from '@mui/material/Popover'

import {
  auth_token_link,
  FAQ_link,
  marketplace_link,
  video_feed_link,
} from 'utils'

import { toast } from 'App'

import { useStore } from 'store'

import authTokenIcon from 'sources/images/authToken.svg'
import menu from 'sources/images/menu.svg'
import menuDark from 'sources/images/menuDark.svg'

import { ThemeSwitch } from '../ThemeSwitch'
import { UnauthorizedUser } from '../UnauthorizedUser'

import styles from './styles.module.scss'

interface IProps {
  onOpenInviteModal: () => void
  onClickHowItWorks: (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void
  onClickWhitepaper: (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void
}

export const BurgerMenu: FC<IProps> = observer(
  ({ onOpenInviteModal, onClickHowItWorks, onClickWhitepaper }) => {
    const { theme, main, profile, authToken } = useStore()

    const handlerClickPrivateRoute = (
      e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
    ) => {
      if (profile.isAuthorizedProfile()) return
      e.preventDefault()
      toast({
        type: 'warning',
        message: `You don't have access to this page. Please connect and select profile.`,
      })
    }

    return (
      <PopupState variant="popover" popupId="main-burger-menu">
        {popupState => {
          return (
            <React.Fragment>
              <button
                {...bindTrigger(popupState)}
                className={styles.burgerMenu}
              >
                <img
                  src={theme.theme === 'light' ? menu : menuDark}
                  alt="menu"
                  className={styles.menu}
                />
              </button>
              <Popover
                {...bindPopover(popupState)}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                sx={{
                  '.MuiPaper-root': {
                    backgroundColor: 'transparent',
                    margin: '5px 0',
                  },
                }}
              >
                <div className={styles.menuBox}>
                  {!(profile.getToken() && profile.selectedUser.NickName) ? (
                    <div className={styles.unauthorizedMenuItem}>
                      <UnauthorizedUser />
                    </div>
                  ) : null}
                  <div className={cn(styles.linkWrap)}>
                    <div
                      onClick={() => {
                        popupState.close()
                        onOpenInviteModal()
                      }}
                      className={styles.linkBurger}
                    >
                      Invite
                    </div>
                  </div>
                  <div className={cn(styles.linkWrap)}>
                    <NavLink className={styles.linkBurger} to={FAQ_link()}>
                      Docs
                    </NavLink>
                  </div>
                  <div className={cn(styles.linkWrap)}>
                    <NavLink
                      onClick={e => handlerClickPrivateRoute(e)}
                      className={styles.linkBurger}
                      to={auth_token_link()}
                    >
                      AUTH Token
                      <div className={styles.AUTHPriceBurgerMenu}>
                        <img src={authTokenIcon} alt="auth" />
                        {`$${authToken.AUTHPrice.USDPriceForAUTH.toFixed(4)}`}
                      </div>
                    </NavLink>
                  </div>
                  <div className={cn(styles.linkWrap)}>
                    <NavLink
                      onClick={e => handlerClickPrivateRoute(e)}
                      className={styles.linkBurger}
                      to={marketplace_link()}
                    >
                      Marketplace
                    </NavLink>
                  </div>

                  <div className={cn(styles.linkWrap)}>
                    <NavLink
                      className={styles.linkBurger}
                      to={video_feed_link()}
                    >
                      Videos
                    </NavLink>
                  </div>

                  {/*Visible linkWrapAdditional only if max-width 576px*/}
                  <div
                    className={cn(styles.linkWrap, styles.linkWrapAdditional)}
                  >
                    <NavLink
                      className={styles.linkBurger}
                      to={''}
                      onClick={onClickHowItWorks}
                    >
                      How it Works
                    </NavLink>
                  </div>
                  <div
                    className={cn(styles.linkWrap, styles.linkWrapAdditional)}
                  >
                    <NavLink
                      className={styles.linkBurger}
                      to={''}
                      onClick={onClickWhitepaper}
                    >
                      Whitepaper
                    </NavLink>
                  </div>

                  {/*Switch*/}
                  <div
                    className={styles.linkWrap}
                    style={{ marginLeft: '3px', width: 'auto' }}
                  >
                    <ThemeSwitch style={{ margin: 0 }} />
                    <div className={styles.linkBurger}>
                      {theme.theme === 'light' ? 'Light' : 'Dark'}
                    </div>
                  </div>
                </div>
              </Popover>
            </React.Fragment>
          )
        }}
      </PopupState>
    )
  }
)

BurgerMenu.displayName = 'BurgerMenu'

export default memo(BurgerMenu)
